import React from 'react';
import Seo from './Seo';

const Privacy = () => {
  return (
    <div className="container mx-auto px-6 py-12">
      <Seo
        title="Privacy Policy | Fusion Tech"
        description="Privacy policy for Fusion Tech website."
        url="https://fusiontechuae.com/privacy"
        noindex
      />

      <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
      <p className="text-gray-700 mb-4">
        This page describes how Fusion Tech may collect and use information when you visit our website.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Information we collect</h2>
      <p className="text-gray-700">
        We may collect basic analytics and information you submit via forms (such as your name, email, phone number, and
        message) to respond to enquiries.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">How we use information</h2>
      <p className="text-gray-700">
        We use information to respond to requests, improve our services, and maintain website security.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Contact</h2>
      <p className="text-gray-700">
        If you have questions about this policy, contact us via the Contact Us page.
      </p>
    </div>
  );
};

export default Privacy;
